import { render, staticRenderFns } from "./SortableItem.vue?vue&type=template&id=66288a4a&"
import script from "./SortableItem.vue?vue&type=script&lang=js&"
export * from "./SortableItem.vue?vue&type=script&lang=js&"
import style0 from "./SortableItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports